import { render, staticRenderFns } from "./VoucherCard.vue?vue&type=template&id=58ba9ae2&scoped=true&"
import script from "./VoucherCard.vue?vue&type=script&lang=js&"
export * from "./VoucherCard.vue?vue&type=script&lang=js&"
import style0 from "./VoucherCard.vue?vue&type=style&index=0&id=58ba9ae2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ba9ae2",
  null
  
)

export default component.exports